export { da } from '@payloadcms/translations/languages/da'
